import classNames from 'classnames';

import { useAuth } from '@/shared/hooks/context/auth';

const Banner: React.FC<{ children: React.ReactNode; bg: string }> = ({
  children,
  bg,
}) => {
  const { collapseState } = useAuth();

  return (
    <div
      className={classNames(
        'relative flex w-screen items-center justify-center py-8 px-16 ltr:-ml-[1rem] rtl:-mr-[1rem] mobile:ltr:-ml-[2.5rem] mobile:rtl:-mr-[2.5rem] tablet:w-auto tablet:ltr:-mr-[2.5rem] tablet:rtl:-ml-[2.5rem]',
        collapseState
          ? 'tablet:ltr:-ml-[26px] tablet:rtl:-mr-[26px]'
          : 'tablet:ltr:-ml-40 tablet:rtl:-mr-40',
        bg
      )}
    >
      {children}
    </div>
  );
};

export default Banner;
